function pnSwiperA11y() {
 const copy = JSON.parse(document.getElementById('pn-original-product-data').textContent).interface;
 return {prevSlideMessage:copy.previous_slide,nextSlideMessage:copy.next_slide,
 firstSlideMessage:copy.first_slide,lastSlideMessage:copy.last_slide,
 paginationBulletMessage:copy.go_to_slide.replace('{number}','{{index}}'),
 slideLabelMessage:copy.slide_position.replace('{number}','{{index}}').replace('{total}','{{slidesLength}}')};
}
try {

  (function() {


    const elDay = document.getElementById('timer-day');
    const elHr = document.getElementById('timer-hr');
    const elMin = document.getElementById('timer-min');
    const elSec = document.getElementById('timer-sec');

    if (!elDay || !elHr || !elMin || !elSec) return;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function updateTimer() {
      const now = new Date();

      // Midnight at the end of today in the visitor's local timezone.
      const endOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0, 0, 0, 0
      );

      let distance = Math.max(
        0,
        Math.floor((endOfDay.getTime() - now.getTime()) / 1000)
      );

      const days = Math.floor(distance / 86400);
      distance %= 86400;

      const hours = Math.floor(distance / 3600);
      distance %= 3600;

      const minutes = Math.floor(distance / 60);
      const seconds = distance % 60;

      elDay.textContent = pad(days);
      elHr.textContent = pad(hours);
      elMin.textContent = pad(minutes);
      elSec.textContent = pad(seconds);
    }
  
    updateTimer();
    setInterval(updateTimer, 1000);
  })();

} catch(error) { console.warn("Original section interaction", error); }
try {

    var shipTimerData = {"timezone":"America/New_York","today_message":"Order within the next $time$ to receive same day shipping.","tomorrow_message":"Order within the next $time$ to have your order ship tomorrow.","fallback_message":"","days":{"0":null,"1":null,"2":null,"3":null,"4":null,"5":null,"6":null},"dates":{"20220427":{"hour":"18","minute":"00"}}};
  
} catch(error) { console.warn("Original section interaction", error); }
try {

   const cwPdpKittySwiper = new Swiper(".cw-pdp-kitty-videoSwiper", {
      a11y: pnSwiperA11y(),
    loop: true,
    slidesPerView: 4, 
    initialSlide: 1,      
    spaceBetween: 18,   
    freeMode: {
      enabled: true,
      sticky: false,  
      momentumBounce: false,
    },
    mousewheel: {
      forceToAxis: true,   
    },
    pagination: {
      el: ".cw-pdp-kitty-swiper-pagination",
      clickable: true,
    },  
    breakpoints: {
    0: {
      // MUDANÇA CRUCIAL AQUI:
      // 'auto' permite que o CSS defina a largura (não mais '1')
      slidesPerView: 'auto', 
      centeredSlides: true, // Centraliza o vídeo na tela
      spaceBetween: 15, // Espaço entre os cards no mobile
    },
    768: {
      slidesPerView: 2, 
      centeredSlides: false,
    },
    1024: {
      slidesPerView: 'auto',
      centeredSlides: false, 
    },
  },
  });
  
  const swiperVideos = document.querySelectorAll(".cw-pdp-kitty-videoSwiper video");
  
  swiperVideos.forEach(video => {
    video.addEventListener("click", function (e) {
      e.preventDefault();
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  });
  
  document.addEventListener("play", function (e) {
    if (e.target.tagName === "VIDEO" && e.target.closest('.cw-pdp-kitty-videoSwiper')) {
      swiperVideos.forEach(video => {
        if (video !== e.target) {
          video.pause();
        }
      });
    }
  }, true);

} catch(error) { console.warn("Original section interaction", error); }
try {

  function initSwiper() {
    new Swiper(".cw-pdp-kitty-rvsSwiper", {
      a11y: pnSwiperA11y(),
      loop: true,
      slidesPerView: 3,
      spaceBetween: 20,
      initialSlide: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        1024: { slidesPerView: 3 }
      }
    });
  }

  

  (function whenReady() {
    if (typeof Swiper === 'undefined') return setTimeout(whenReady, 50);
    initSwiper();
  })();

} catch(error) { console.warn("Original section interaction", error); }
try {

  setTimeout(function () {
    document.querySelectorAll('.cw-pdp-faq-item').forEach(function (item) {
      const question = item.querySelector('.cw-pdp-faq-question');
      question.addEventListener('click', function () {
        const isActive = item.classList.contains('active');
        document.querySelectorAll('.cw-pdp-faq-item').forEach(function (el) {
          el.classList.remove('active');
          el.querySelector('.cw-pdp-faq-answer').style.display = 'none';
          el.querySelector('.cw-pdp-faq-showbtn').style.display = 'inline';
          el.querySelector('.cw-pdp-faq-hidebtn').style.display = 'none';
        });
        if (!isActive) {
          item.classList.add('active');
          item.querySelector('.cw-pdp-faq-answer').style.display = 'block';
          item.querySelector('.cw-pdp-faq-showbtn').style.display = 'none';
          item.querySelector('.cw-pdp-faq-hidebtn').style.display = 'inline';
        }
      });
    });
  }, 500);

} catch(error) { console.warn("Original section interaction", error); }